var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIconGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H20C26.6274 0 32 5.37258 32 12V20C32 26.6274 26.6274 32 20 32H12C5.37258 32 0 26.6274 0 20V12Z",
    fill: "#F5F9FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0007 17.3335C10.3688 17.3335 10.6673 17.632 10.6673 18.0002V20.6668C10.6673 20.8436 10.7376 21.0132 10.8626 21.1382C10.9876 21.2633 11.1572 21.3335 11.334 21.3335H20.6673C20.8441 21.3335 21.0137 21.2633 21.1387 21.1382C21.2637 21.0132 21.334 20.8436 21.334 20.6668V18.0002C21.334 17.632 21.6325 17.3335 22.0007 17.3335C22.3688 17.3335 22.6673 17.632 22.6673 18.0002V20.6668C22.6673 21.1973 22.4566 21.706 22.0815 22.081C21.7065 22.4561 21.1978 22.6668 20.6673 22.6668H11.334C10.8036 22.6668 10.2948 22.4561 9.91977 22.081C9.5447 21.706 9.33398 21.1973 9.33398 20.6668V18.0002C9.33398 17.632 9.63246 17.3335 10.0007 17.3335Z",
    fill: "#16192C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1953 14.1953C12.4556 13.9349 12.8777 13.9349 13.1381 14.1953L16 17.0572L18.8619 14.1953C19.1223 13.9349 19.5444 13.9349 19.8047 14.1953C20.0651 14.4556 20.0651 14.8777 19.8047 15.1381L16.4714 18.4714C16.2111 18.7318 15.7889 18.7318 15.5286 18.4714L12.1953 15.1381C11.9349 14.8777 11.9349 14.4556 12.1953 14.1953Z",
    fill: "#16192C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0007 9.3335C16.3688 9.3335 16.6673 9.63197 16.6673 10.0002V18.0002C16.6673 18.3684 16.3688 18.6668 16.0007 18.6668C15.6325 18.6668 15.334 18.3684 15.334 18.0002V10.0002C15.334 9.63197 15.6325 9.3335 16.0007 9.3335Z",
    fill: "#16192C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIconGrey);
export default __webpack_public_path__ + "static/media/download-icon-grey.b98a4446d6e3aa0f2bdf2e234cd90482.svg";
export { ForwardRef as ReactComponent };